import React from 'react';
import './AvatarModal.css';

const AvatarModal = ({ showAvatar, setShowAvatar, mode, avatarUrl, setFormData, setSubmitted }) => {
  if (!showAvatar) return null;

  return (
    <div className="avatar-modal-overlay">
      <div className="avatar-modal-container">
        <div className="avatar-header">
          <h3>{mode === 'interviewer' ? 'AI Interviewer' : mode === 'tutor' ? 'AI Tutor' : 'AI Counsellor'}</h3>
          <button
            className="close-modal-btn"
            onClick={() => {
              setShowAvatar(false);
              setFormData({ name: '', resume: null, topic: '' });
              setSubmitted(false);
            }}
          >
            ✕ Close
          </button>
        </div>
        <div className="avatar-iframe-wrapper">
          {avatarUrl ? (
            <iframe
              src={avatarUrl}
              title="Beyond Presence Avatar"
              allow="camera; microphone; autoplay; encrypted-media"
              className="avatar-iframe"
            />
          ) : (
            <div className="avatar-config-warning">
              <h4>Avatar agent is not configured</h4>
              <p>
                Please ensure you have configured valid API keys.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AvatarModal;
